export enum ArchivingScopesEnum {
	// Import
	ImportDelete = '[Archiving] Import Delete',
	ImportExport = '[Archiving] Import Export',
	ImportList = '[Archiving] Import List',
	ImportRead = '[Archiving] Import Read',
	ImportRefreshEntity = '[Archiving] Import Refresh Entity',
	ImportRefreshList = '[Archiving] Import Refresh List',

	// Import CashPointClosing
	ImportCashPointClosingList = '[Archiving] Import CashPointClosing List',
	ImportCashPointClosingRead = '[Archiving] Import CashPointClosing Read',
	ImportCashPointClosingRefreshEntity = '[Archiving] Import CashPointClosing Refresh Entity',
	ImportCashPointClosingRefreshList = '[Archiving] Import CashPointClosing Refresh List',

	// Import TssLog
	ImportTssLogExport = '[Archiving] Import TssLog Export',
	ImportTssLogDownload = '[Archiving] Import TssLog Download',
	ImportTssLogList = '[Archiving] Import TssLog List',
	ImportTssLogRead = '[Archiving] Import TssLog Read',
	ImportTssLogRefreshEntity = '[Archiving] Import TssLog Refresh Entity',
	ImportTssLogRefreshList = '[Archiving] Import TssLog Refresh List',

	// Export
	ExportDownload = '[Archiving] Export Download',
	ExportExtend = '[Archiving] Export Extend',
	ExportList = '[Archiving] Export List',
	ExportRead = '[Archiving] Export Read',
	ExportRefreshEntity = '[Archiving] Export Refresh Entity',
	ExportRefreshList = '[Archiving] Export Refresh List',

	// Export Item
	ExportItemList = '[Archiving] Export Item List',
	ExportItemRead = '[Archiving] Export Item Read',
	ExportItemRefreshEntity = '[Archiving] Export Item Refresh Entity',
	ExportItemRefreshList = '[Archiving] Export Item Refresh List',

	// Export TssLog
	ExportTssLogDownload = '[Archiving] Export TssLog Download',
	ExportTssLogExtend = '[Archiving] Export TssLog Extend',
	ExportTssLogList = '[Archiving] Export TssLog List',
	ExportTssLogRead = '[Archiving] Export TssLog Read',
	ExportTssLogRefreshEntity = '[Archiving] Export TssLog Refresh Entity',
	ExportTssLogRefreshList = '[Archiving] Export TssLog Refresh List',

	// Procedural Documentation
	ProceduralDocumentationArchive = '[Archiving] Procedural Documentation Archive',
	ProceduralDocumentationDelete = '[Archiving] Procedural Documentation Delete',
	ProceduralDocumentationEdit = '[Archiving] Procedural Documentation Edit',
	ProceduralDocumentationExport = '[Archiving] Procedural Documentation Export',
	ProceduralDocumentationImport = '[Archiving] Procedural Documentation Import',
	ProceduralDocumentationList = '[Archiving] Procedural Documentation List',
	ProceduralDocumentationRead = '[Archiving] Procedural Documentation Read',
	ProceduralDocumentationRefreshEntity = '[Archiving] Procedural Documentation Refresh Entity',
	ProceduralDocumentationRefreshList = '[Archiving] Procedural Documentation Refresh List',
	ProceduralDocumentationReplace = '[Archiving] Procedural Documentation Replace',

	// Procedural Document
	ProceduralDocumentList = '[Archiving] Procedural Document List',
	ProceduralDocumentRead = '[Archiving] Procedural Document Read',
	ProceduralDocumentRefreshEntity = '[Archiving] Procedural Document Refresh Entity',
	ProceduralDocumentRefreshList = '[Archiving] Procedural Document Refresh List',

	// Export Procedural Documentation
	ExportProceduralDocumentationDownload = '[Archiving] Export Procedural Documentation Download',
	ExportProceduralDocumentationExtend = '[Archiving] Export Procedural Documentation Extend',
	ExportProceduralDocumentationList = '[Archiving] Export Procedural Documentation List',
	ExportProceduralDocumentationRead = '[Archiving] Export Procedural Documentation Read',
	ExportProceduralDocumentationRefreshEntity = '[Archiving] Export Procedural Documentation Refresh Entity',
	ExportProceduralDocumentationRefreshList = '[Archiving] Export Procedural Documentation Refresh List',

	// Open Archive
	OpenArchiveCreate = '[Archiving] Open Archive Create',
	OpenArchiveDelete = '[Archiving] Open Archive Delete',
	OpenArchiveEdit = '[Archiving] Open Archive Edit',
	OpenArchiveList = '[Archiving] Open Archive List',
	OpenArchiveRead = '[Archiving] Open Archive Read',
	OpenArchiveRefreshEntity = '[Archiving] Open Archive Refresh Entity',
	OpenArchiveRefreshList = '[Archiving] Open Archive Refresh List',

	// Open Archive Export
	OpenArchiveExportCreate = '[Archiving] Open Archive Export Create',
	OpenArchiveExportDownload = '[Archiving] Open Archive Export Download',
	OpenArchiveExportExtend = '[Archiving] Open Archive Export Extend',
	OpenArchiveExportList = '[Archiving] Open Archive Export List',
	OpenArchiveExportRead = '[Archiving] Open Archive Export Read',
	OpenArchiveExportRefreshEntity = '[Archiving] Open Archive Export Refresh Entity',
	OpenArchiveExportRefreshList = '[Archiving] Open Archive Export Refresh List',
}

export enum BusinessPremisesScopesEnum {
	ACCESS_ARCHIVING_CONTENT = '[BusinessPremises] Access Archiving Content',
	ACCESS_FISKAL_CONTENT = '[BusinessPremises] Access Fiskal Content',
	ACCESS_CONFIGURATION = '[BusinessPremises] Access Configuration',
	CONFIGURATION_ACCOUNT_SETTINGS = '[BusinessPremises] Configuration Account Settings',
	CONFIGURATION_ACCOUNT_SETTINGS_MODIFY = '[BusinessPremises] Configuration Account Settings Modify',
	CONFIGURATION_ACCOUNT_SETTINGS_ARCHIVE = '[BusinessPremises] Configuration Account Settings Archive',
	CONFIGURATION_ACCOUNT_SETTINGS_ARCHIVE_ALLOW_DISABLE = '[BusinessPremises] Configuration Account Settings Archive Allow Disable',
	CONFIGURATION_ACCOUNT_SETTINGS_ARCHIVE_ALLOW_ENABLE = '[BusinessPremises] Configuration Account Settings Archive Allow Enable',
	CONFIGURATION_ACCOUNT_SETTINGS_ELSTER = '[BusinessPremises] Configuration Account Settings Elster',
	CONFIGURATION_ACCOUNT_SETTINGS_ELSTER_ENABLE_TAXATION_REPORTING_ALLOW_DISABLE = '[BusinessPremises] Configuration Account Settings Elster Enable Taxation Reporting  Allow Disable',
	CONFIGURATION_ACCOUNT_SETTINGS_ELSTER_ENABLE_TAXATION_REPORTING_ALLOW_ENABLE = '[BusinessPremises] Configuration Account Settings Elster Enable Taxation Reporting  Allow Enable',
	CONFIGURATION_TSS_EXPORT = '[BusinessPremises] Configuration Tss Export',
	CONFIGURATION_TSS_EXPORT_MODIFY = '[BusinessPremises] Configuration Tss Export Modify',
	CONFIGURATION_TSS_EXPORT_RESET_SCHEDULING = '[BusinessPremises] Configuration Tss Export Reset Scheduling',
	CONFIGURATION_TSS_EXPORT_MANUAL_EXPORT = '[BusinessPremises] Configuration Tss Export Manual Export',
	CREATE = '[BusinessPremises] Create',
	DATA_INTEGRITY_ERRORS = '[BusinessPremises] Data Integrity Errors',
	DELETE = '[BusinessPremises] Delete',
	LIST = '[BusinessPremises] List',
	READ = '[BusinessPremises] Read',
	REFRESH_ENTITY = '[BusinessPremises] Refresh Entity',
	REFRESH_LIST = '[BusinessPremises] Refresh List',
	REQUEST_RESOURCE_LOCK_LIST = '[BusinessPremises] Request List Of Resource Lock',
	STATUS_DISABLE = '[BusinessPremises] Status Disable',
	STATUS_ENABLE = '[BusinessPremises] Status Enable',
	UPDATE = '[BusinessPremises] Update',
}

export enum ClientScopesEnum {
	Create = '[Client] Create',
	Delete = '[Client] Delete',
	List = '[Client] List',
	Read = '[Client] Read',
	RefreshEntity = '[Client] Refresh Entity',
	RefreshList = '[Client] Refresh List',
	ResetPassword = '[Client] Reset Password',
	Update = '[Client] Update',
}

export enum ContractScopesEnum {
	ACCESS_FCC_CONTENT = '[Contract] Access Fcc Content',
	Create = '[Contract] Create',
	List = '[Contract] List',
	Read = '[Contract] Read',
	RefreshEntity = '[Contract] Refresh Entity',
	RefreshList = '[Contract] Refresh List',
	Update = '[Contract] Update',
}

export enum EncryptionKeyScopesEnum {
	Create = '[EncryptionKey] Create',
	Download = '[EncryptionKey] Download',
	List = '[EncryptionKey] List',
	Renew = '[EncryptionKey] Renew',
}

export enum ErsScopesEnum {
	Create = '[Ers] Create',
	DATA_INTEGRITY_ERRORS = '[Ers] Data Integrity Errors',
	Delete = '[Ers] Delete',
	List = '[Ers] List',
	Read = '[Ers] Read',
	RefreshEntity = '[Ers] Refresh Entity',
	RefreshList = '[Ers] Refresh List',
	StatusDisable = '[Ers] Status Disable',
	StatusInactivate = '[Ers] Status Inactivate',
	StatusSuspend = '[Ers] Status Suspend',
	StatusEnable = '[Ers] Status Enable',
	Update = '[Ers] Update'
}

export enum ErsExternalScopesEnum {
	Create = '[ErsExternal] Create',
	Delete = '[ErsExternal] Delete',
	List = '[ErsExternal] List',
	Read = '[ErsExternal] Read',
	RefreshEntity = '[ErsExternal] Refresh Entity',
	RefreshList = '[ErsExternal] Refresh List',
	StatusDisable = '[ErsExternal] Status Disable',
	StatusInactivate = '[ErsExternal] Status Inactivate',
	StatusEnable = '[ErsExternal] Status Enable',
	Update = '[ErsExternal] Update'
}

export enum FccVersionScopesEnum {
	ACCESS_FCC_VERSION_CONTENTS = '[FccVersion] Access Fcc Version Content',
	CREATE = '[FccVersion] Create',
	DELETE = '[FccVersion] Delete',
	LIST = '[FccVersion] List',
	REFRESH_LIST = '[FccVersion] Refresh List',
	UPDATE = '[FccVersion] Update'
}

export enum FeatureScopesEnum {
	ERIC = '[Feature] Elster'
}

export enum FiskalScopesEnum {
	TssLogAcknowledge = '[Fiskal] TssLog Acknowledge',
	TssLogDownload = '[Fiskal] TssLog Download',
	TssLogList = '[Fiskal] TssLog List',
	TssLogRead = '[Fiskal] TssLog Read',
	TssLogRefreshEntity = '[Fiskal] TssLog Refresh Entity',
	TssLogRefreshList = '[Fiskal] TssLog Refresh List',
}

export enum KeywordScopesEnum {
	Create = '[Keyword] Create',
	Delete = '[Keyword] Delete',
	List = '[Keyword] List',
	Read = '[Keyword] Read',
	Update = '[Keyword] Update',
}

export enum MyAccountScopesEnum {
	Update = '[MyAccount] Update',
}

export enum NotificationScopesEnum {
	LIST = '[Notification] List',
	READ = '[Notification] Read',
	REFRESH_ENTITY = '[Notification] Refresh Entity',
	REFRESH_LIST = '[Notification] Refresh List',
}

export enum OrganizationScopesEnum {
	Create = '[Organization] Create',
	DATA_INTEGRITY_ERRORS = '[Organization] Data Integrity Errors',
	Delete = '[Organization] Delete',
	List = '[Organization] List',
	Read = '[Organization] Read',
	RefreshEntity = '[Organization] Refresh Entity',
	RefreshList = '[Organization] Refresh List',
	StatusDisable = '[Organization] Status Disable',
	StatusEnable = '[Organization] Status Enable',
	StructureImport = '[Organization] StructureImport',
	Update = '[Organization] Update',
}

export enum OutageEventScopesEnum {
	AccessOutageEventContent = '[OutageEvent] Access Outage Event Content',
	List = '[OutageEvent] List',
	Read = '[OutageEvent] Read',
	RefreshEntity = '[OutageEvent] Refresh Entity',
	RefreshList = '[OutageEvent] Refresh List',
	Update = '[OutageEvent] Update',
}

export enum StatisticsScopesEnum {
	ACCESS_GLOBAL_STATISTICS_CONTENTS = '[Statistics] Access Global Statistics Content',
	ReadArchivingContent = '[Statistics] Read Archiving Content',
	ReadFiskalContent = '[Statistics] Read Fiskal Content',
}

export enum StructureExportScopesEnum {
	Download = '[StructureExport] Download',
	ExportBusinessPremises = '[StructureExport] Export BusinessPremises',
	ExportOrganization = '[StructureExport] Export Organization ',
	ExportTenant = '[StructureExport] Export Tenant',
	List = '[StructureExport] List',
	Read = '[StructureExport] Read',
	RefreshEntity = '[StructureExport] Refresh Entity',
	RefreshList = '[StructureExport] Refresh List',
}

export enum StructureImportScopesEnum {
	IMPORT_BUSINESS_PREMISES = '[StructureImport] Import BusinessPremises',
	IMPORT_ERS = '[StructureImport] Import Ers',
	IMPORT_ERS_EXTERNAL = '[StructureImport] Import ErsExternal',
	IMPORT_ORGANIZATION = '[StructureImport] Import Organization ',
	IMPORT_TENANT = '[StructureImport] Import Tenant',
	IMPORT_TSS_EXTERNAL = '[StructureImport] Import TssExternal',
	LIST = '[StructureImport] List',
	READ = '[StructureImport] Read',
	REFRESH_ENTITY = '[StructureImport] Refresh Entity',
	DOWNLOAD_ENTITY_DATA = '[StructureImport] Download Entity Data',
	REFRESH_LIST = '[StructureImport] Refresh List',
}

export enum SupportAdminScopesEnum {
	CREATE = '[SupportAdmin] Create',
	DELETE = '[SupportAdmin] Delete',
	LIST = '[SupportAdmin] List',
	READ = '[SupportAdmin] Read',
	UPDATE = '[SupportAdmin] Update',
	IS_SUPPORT_ADMIN = '[SupportAdmin] IsSupportAdmin'
}

export enum TaskScopesEnum {
	ACCESS_TASK_CENTER = '[Task] access task center',
	ACCESS_DATA_INTEGRITY_ERRORS_TASK = '[Task] access data integrity errors task',
	ACCESS_FCC_OPEN_TRANSACTIONS_TASK = '[Task] access fcc open transactions task',
	ACCESS_FCC_VERSIONS_TASK = '[Task] access fcc versions task',
	ACCESS_FISKAL_TSS_LOGS_TASK = '[Task] access fiskal tss logs task',
	ACCESS_MISSING_CUSTOMER_IDS_TASK = '[Task] access missing customerIds task',
	ACCESS_NOTIFICATIONS_TASK = '[Task] access notifications task',
	ACCESS_OUTAGES_TASK = '[Task] access outages task',
	ACCESS_TSS_PRE_INITIALIZATION_TASK = '[Task] tss pre-initialization task',
	MISSING_CUSTOMER_IDS_TASK_EDIT_TENANT = '[Task] Missing customerIds task edit tenant',
}

export enum TaxationScopesEnum {
	INDICATOR_SHOW = '[Taxation] Indicator Show',
	REPORTING_ACKNOWLEDGE = '[Taxation] Reporting Acknowledge',
	REPORTING_CREATE = '[Taxation] Reporting Create',
	REPORTING_DOWNLOAD = '[Taxation] Reporting Download',
	REPORTING_REFRESH_ENTITY = '[Taxation] Reporting Refresh Entity',
	REPORTING_REFRESH_LIST = '[Taxation] Reporting Refresh List',
	REPORTING_LIST = '[Taxation] Reporting List',
	REPORTING_READ = '[Taxation] Reporting Read',
	REPORTING_SUBMIT = '[Taxation] Reporting Submit'
}

export enum TenantScopesEnum {
	ACCESS_CONFIGURATION_ACCOUNT = '[Tenant] Access Configuration Account',
	TENANT_CONFIGURATION_ACCESS = '[Tenant] Access Configuration Tenant',
	CONFIGURATION_ACCOUNT_TSS_LOG_EXPIRATION_NOTIFICATION = '[Tenant] Configuration Account Tss Log Expiration Notification',
	CONFIGURATION_ACCOUNT_TSS_LOG_EXPIRATION_NOTIFICATION_MODIFY = '[Tenant] Configuration Account Tss Log Expiration Notification Modify',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS = '[Tenant] Configuration Tenant Account Settings',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ARCHIVE = '[Tenant] Configuration Tenant Account Settings Archive',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ARCHIVE_ALLOW_DISABLE = '[Tenant] Configuration Tenant Account Settings Archive Allow Disable',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ARCHIVE_ALLOW_ENABLE = '[Tenant] Configuration Tenant Account Settings Archive Allow Enable',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ARCHIVE_STRICT_REFERENCE_CHECK = '[Tenant] Configuration Tenant Account Settings Archive StrictReferenceCheck',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ARCHIVE_STRICT_REFERENCE_CHECK_ALLOW_DISABLE =
		'[Tenant] Configuration Tenant Account Settings Archive StrictReferenceCheck Allow Disable',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ARCHIVE_STRICT_REFERENCE_CHECK_ALLOW_ENABLE =
		'[Tenant] Configuration Tenant Account Settings Archive StrictReferenceCheck Allow Enable',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ARCHIVE_ERS_CHECK = '[Tenant] Configuration Tenant Account Settings Archive ErsCheck',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ARCHIVE_ERS_CHECK_ALLOW_DISABLE = '[Tenant] Configuration Tenant Account Settings Archive ErsCheck Allow Disable',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ARCHIVE_ERS_CHECK_ALLOW_ENABLE = '[Tenant] Configuration Tenant Account Settings Archive ErsCheck Allow Enable',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ARCHIVE_OPEN_ARCHIVE_MANAGE_KEYWORDS =
		'[Tenant] Configuration Tenant Account Settings Archive OpenArchive ManageKeywords',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ELSTER = '[Tenant] Configuration Tenant Account Settings ELSTER',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ELSTER_ACCESS_ENABLE_TAXATION_REPORTING_EXPIRATION =
		'[Tenant] Configuration Tenant Account Settings Elster Access Enable Taxation Reporting Expiration',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ELSTER_ENABLE_TAXATION_REPORTING_ALLOW_DISABLE =
		'[Tenant] Configuration Tenant Account Settings Elster Enable Taxation Reporting Allow Disable',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ELSTER_ENABLE_TAXATION_REPORTING_ALLOW_ENABLE =
		'[Tenant] Configuration Tenant Account Settings Elster Enable Taxation Reporting Allow Enable',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ELSTER_ACCESS_TAXATION_REPORTING_DISABLE_EXPIRATION =
		'[Tenant] Configuration Tenant Account Settings Elster Access Taxation Reporting Disable Expiration',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ELSTER_TAXATION_REPORTING_DISABLE_EXPIRATION_ALLOW_DISABLE =
		'[Tenant] Configuration Tenant Account Settings Elster Taxation Reporting Disable Expiration Allow Disable',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_ELSTER_TAXATION_REPORTING_DISABLE_EXPIRATION_ALLOW_ENABLE =
		'[Tenant] Configuration Tenant Account Settings Elster Taxation Reporting Disable Expiration Allow Enable',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_FISKAL = '[Tenant] Configuration Tenant Account Settings Fiskal',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_FISKAL_ACCESS_DISABLE_TSS_LOG_EXPIRATION =
		'[Tenant] Configuration Tenant Account Settings Fiskal Access Disable TssLog Expiration',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_FISKAL_DISABLE_TSS_LOG_EXPIRATION_ALLOW_DISABLE =
		'[Tenant] Configuration Tenant Account Settings Fiskal Disable TssLog Expiration Allow Disable',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_FISKAL_DISABLE_TSS_LOG_EXPIRATION_ALLOW_ENABLE =
		'[Tenant] Configuration Tenant Account Settings Fiskal Disable TssLog Expiration Allow Enable',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_FISKAL_ACCESS_POSTPONED_REMOVAL_ACK_TSS_LOGS =
		'[Tenant] Configuration Tenant Account Settings Fiskal Access Postponed Removal Acknowledged TssLogs',
	CONFIGURATION_TENANT_ACCOUNT_SETTINGS_FISKAL_POSTPONED_REMOVAL_ACK_TSS_LOGS_ALLOW_CHANGE =
		'[Tenant] Configuration Tenant Account Settings Fiskal Postponed Removal Acknowledged TssLogs Allow Change',
	CONFIGURATION_TENANT_ENCRYPTION_KEY = '[Tenant] Configuration Tenant Encryption Key',
	CONFIGURATION_TENANT_ENCRYPTION_KEY_MODIFY = '[Tenant] Configuration Tenant Encryption Key Modify',
	CONFIGURATION_TENANT_TSS_EXPORT = '[Tenant] Configuration Tenant Tss Export',
	CONFIGURATION_TENANT_TSS_EXPORT_MODIFY = '[Tenant] Configuration Tenant Tss Modify',
	CONFIGURATION_TENANT_TSS_EXPORT_RESET_SCHEDULING = '[Tenant] Configuration Tenant Tss Export Reset Scheduling',
	Create = '[Tenant] Create',
	CreateSubaccount = '[Tenant] Create Subaccount',
	Delete = '[Tenant] Delete',
	List = '[Tenant] List',
	ManageTenant = '[Tenant] ManageTenant',
	ReadOwn = '[Tenant] Read Own',
	Read = '[Tenant] Read All',
	RefreshEntity = '[Tenant] Refresh Entity',
	RefreshList = '[Tenant] Refresh List',
	StatusDisable = '[Tenant] Status Disable',
	StatusEnable = '[Tenant] Status Enable',
	Update = '[Tenant] Update',
}

export enum TssScopesEnum {
	ACCESS_FCC_CONTENT = '[Tss] Access Fcc Content',
	CopyAll = '[Tss] Copy All',
	Create = '[Tss] Create',
	CONFIRM_FINAL_TSS_LOG_EXPORT = '[Tss] Confirm Final Tss Log Export',
	Delete = '[Tss] Delete',
	List = '[Tss] List',
	PasswordRead = '[Tss] Password Read',
	PasswordRenew = '[Tss] Password Renew',
	Print = '[Tss] Print',
	Read = '[Tss] Read',
	RefreshEntity = '[Tss] Refresh Entity',
	RefreshList = '[Tss] Refresh List',
	StatusDisable = '[Tss] Status Disable',
	StatusEnable = '[Tss] Status Enable',
	TokenCreate = '[Tss] Token Create',
	TokenRead = '[Tss] Token Read',
	TriggerErsSync = '[Tss] Trigger Ers Sync',
	TRIGGER_FCC_DATACENTER_INSTALLATION = '[Tss] Trigger Fcc Datacenter Installation',
	TRIGGER_TSS_LOG_UPLOAD = '[Tss] Trigger TssLog Upload',
	Update = '[Tss] Update',
}

export enum TssExternalScopesEnum {
	Create = '[TssExternal] Create',
	Delete = '[TssExternal] Delete',
	List = '[TssExternal] List',
	Read = '[TssExternal] Read',
	RefreshEntity = '[TssExternal] Refresh Entity',
	RefreshList = '[TssExternal] Refresh List',
	StatusDisable = '[TssExternal] Status Disable',
	StatusInactivate = '[Ers] Status Inactivate',
	StatusEnable = '[TssExternal] Status Enable',
	Update = '[TssExternal] Update',
}

export enum UsageDtrScopesEnum {
	ACCESS_DTR_CONTENTS = '[UsageDtr] Access DTR Contents',
	ACCESS_DTR_USAGE_CONTENT = '[UsageDtr] Access DTR Usage Content',
	ACCESS_DTR_VOLUME_CONTENT = '[UsageDtr] Access DTR Volume Content',
}

export enum UsageFiskalScopesEnum {
	ACCESS_FCC_CONTENT = '[UsageFiskal] Access Fcc Content',
	BUSINESS_PREMISES = '[UsageFiskal] BusinessPremises',
	CONTRACT = '[UsageFiskal] Contract',
	ORGANIZATION = '[UsageFiskal] Organization',
	TENANT_ACCOUNT = '[UsageFiskal] Tenant Account',
	TENANT_CURRENT_USER = '[UsageFiskal] Tenant Current User'
}

export enum UsageGkScopesEnum {
	ACCESS_GK_CONTENTS = '[UsageGk] Access GK Contents',
	ACCESS_GK_USAGE_CONTENT = '[UsageGk] Access GK Usage Content',
}

export enum UsageArchivingScopesEnum {
	BUSINESS_PREMISES = '[UsageArchiving] BusinessPremises',
	CONTRACT = '[UsageArchiving] Contract',
	ORGANIZATION = '[UsageArchiving] Organization',
	TENANT_ACCOUNT = '[UsageArchiving] Tenant Account',
	TENANT_CURRENT_USER = '[UsageArchiving] Tenant Current User'
}

export enum UsageElsterScopesEnum {
	BUSINESS_PREMISES = '[UsageElster] BusinessPremises',
	CONTRACT = '[UsageElster] Contract',
	ORGANIZATION = '[UsageElster] Organization',
	TENANT_ACCOUNT = '[UsageElster] Tenant Account',
	TENANT_CURRENT_USER = '[UsageElster] Tenant Current User'
}

export enum UserScopesEnum {
	ACCESS_ALL_USERS_CONTENTS = '[User] Access All Users Contents',
	CHANGE_PASSWORD = '[User] Change Password',
	CHANGE_PASSWORD_CURRENT_USER = '[User] Change Password Current User',
	CREATE = '[User] Create',
	DELETE = '[User] Delete',
	LIST = '[User] List',
	READ = '[User] Read',
	REFRESH_ENTITY = '[User] Refresh Entity',
	REFRESH_LIST = '[User] Refresh List',
	STATUS_DISABLE = '[User] Status Disable',
	STATUS_ENABLE = '[User] Status Enable',
	UPDATE = '[User] Update',
	UPDATE_CURRENT_USER = '[User] Update Current User',
	USER_AUDIT_ADMIN = '[User] User Audit Admin',
	USER_AUDIT_USER = '[User] User Audit User'
}

export enum ScopePermissionCheckEnum {
	AND = 'and',
	OR = 'or'
}

export enum ScopeActionEnum {
	DISABLE = 'disable',
	HIDE = 'hide'
}

export type ApplicationScopeTypes =
	ArchivingScopesEnum |
	BusinessPremisesScopesEnum |
	ClientScopesEnum |
	ContractScopesEnum |
	EncryptionKeyScopesEnum |
	ErsScopesEnum |
	ErsExternalScopesEnum |
	FccVersionScopesEnum |
	FiskalScopesEnum |
	FeatureScopesEnum |
	KeywordScopesEnum |
	MyAccountScopesEnum |
	NotificationScopesEnum |
	OrganizationScopesEnum |
	OutageEventScopesEnum |
	StatisticsScopesEnum |
	StructureExportScopesEnum |
	StructureImportScopesEnum |
	SupportAdminScopesEnum |
	TaskScopesEnum |
	TaxationScopesEnum |
	TenantScopesEnum |
	TssScopesEnum |
	TssExternalScopesEnum |
	UsageArchivingScopesEnum |
	UsageElsterScopesEnum |
	UsageDtrScopesEnum |
	UsageFiskalScopesEnum |
	UsageGkScopesEnum |
	UserScopesEnum;
